




import { defineComponent, useRoute } from '@nuxtjs/composition-api'
import { usePage } from '@/hooks/twill'

export default defineComponent({
    setup() {
        const route = useRoute()
        const { loadPage } = usePage(route.value.params.slug)
        loadPage()
    },
})
